export const getUserInfo = (client, fields, infoParticipationType) => {
    const initInfo = { ...(client?.info || {}) };

    const info = (fields || []).reduce((acc, field) => {
        if (field.defaultValue) {
            acc[field.name] = field.defaultValue
        }

        return acc;
    }, initInfo);

    if (infoParticipationType) {
        info.participationType = infoParticipationType;
    }

    return info;
};
